import { FC } from 'react';
import { Container } from './components';

const Cancelled: FC = () => {
  return (
    <Container>
      <p>Cet entretien a été annulé. </p>
    </Container>
  );
};

export default Cancelled;
